import { Body } from '@panwds/react-ui'
import { useEffect, useState } from 'react'
import { ELA_LICENSE_MESSAGE } from '../../../common/constants/LabelConstants'
import type { CommonStoreState } from '../../store'

type ElaLicenseInfoProps = {
  state: CommonStoreState
}
const ElaLicenseInfo = (props: ElaLicenseInfoProps) => {
  const { state } = props
  const [elaLicInfo, setElaLicInfo] = useState(Boolean)
  useEffect(() => {
    const primaryAppId = state?.manifest?.primary_app_id || null
    const licenseDetails = primaryAppId ? state.licenses?.get(primaryAppId) : null
    const hasElaLicenses = licenseDetails?.licenses?.every(l => l.is_ela) || false
    setElaLicInfo(hasElaLicenses)
  }, [state?.manifest, state?.licenses, setElaLicInfo])

  return elaLicInfo ? (
    <div className='tw-justify-ceneter tw-pb-1 tw-pt-0'>
      <Body appearance={'secondary'}>{`${ELA_LICENSE_MESSAGE}`}</Body>
    </div>
  ) : <></>
}

export default ElaLicenseInfo
